import React from 'react'
import Image from 'next/image'
import styles from './enterpriseBreadcrumb.module.scss'

interface EnterpriseBreadcrumbProps {
  data: any
}

const LEFT_CHEVRON = 'https://acko-cms.ackoassets.com/left_chevron_e6b1817ec1.png'

const EnterpriseBreadcrumb = ({ data }: EnterpriseBreadcrumbProps) => {
  const responseArray = Array.isArray(data) ? data : [data]

  if (!responseArray || responseArray.length === 0) {
    return null
  }

  const onClickBack = () => {
    window.location.href = responseArray[responseArray.length - 2]?.url || '/enterprise'
  }

  return (
    <>
      <div className={styles.breadcrumbContainer}>
        {responseArray.map((item, index) => (
          <span key={`${item.label}-${index}`} className={styles.breadcrumbItem}>
            {item.url ? (
              <a href={item.url} className={styles.breadcrumbLink}>
                {item.label}
              </a>
            ) : (
              <span className={styles.breadcrumbText}>{item.label}</span>
            )}
            {index !== responseArray.length - 1 && <span className={styles.breadcrumbDivider}> &gt; </span>}
          </span>
        ))}
      </div>
      <button type="button" className={styles.mobileBack} onClick={onClickBack}>
        <Image src={LEFT_CHEVRON} alt="back" width={16} height={16} />
        <p>Back</p>
      </button>
    </>
  )
}

export default EnterpriseBreadcrumb
